import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const Grid = ({ columns, rows }) => {
    return (
        <DataGrid
            columns={columns}
            rows={rows}
            getRowId={(rows) => rows.product}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            autoHeight={true}
            headerHeight={64}
            rowHeight={56}
            sx={{
                "&>.MuiDataGrid-main": {
                    "& .MuiDataGrid-columnHeader": {
                        borderTop: '1px solid #ECECEC'
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontSize: 16,
                        fontWeight: 600,
                    }
                },
                "&.MuiDataGrid-root .MuiDataGrid-cell": {
                    borderTop: '1px solid #ECECEC'
                },
                borderColor: "transparent"
            }}
        />
    )
}

export default Grid